module.exports = __webpack_public_path__ + "static/media/stemmy.6a0b4916.svg";